// extracted by mini-css-extract-plugin
module.exports = {"search-header-row":"SearchOverlay_search-header-row__2eYhN","hide":"SearchOverlay_hide__379NY"};